<p>
 An entry already exists for the selected Month/Year!
</p>
<p>
 
  Focus Items: {{FocusItemsValue}}
  </p>
  <p>
  Areas of Improvements:  {{AreasImprovementValue}}
  </p>
  <p>
  Positives: {{PositivesValue}}
  </p>
  <p>
  Take5 Target: {{Take5TargetValue}}
  </p>
  <p>
  Safety Inspection Target: {{safetyInspectionValue}}
  </p>
  <!-- <p>
 
    State: {{InputStateValue}}
    </p> -->
<p>
  Do you wish to overwrite?
</p>


<div class="buttonbelow">
  
  <button mat-raised-button (click)= "save()">Ok</button>   
  <button mat-raised-button (click)="DialogClose()">Cancel</button> 
  
    
</div>